// extracted by mini-css-extract-plugin
export default {"header":"MediaFolder_header__c7zOP","thumbnail":"MediaFolder_thumbnail__0k2HJ"};